module.exports = __webpack_public_path__ + "img/85ne.e39dfa7e.svg";